// Generated by Ktorfit
@file:Suppress("warnings")

package kpt.core.network.fred.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kpt.core.base.network.`annotation`.ApiBinding
import kpt.core.network.fred.dto.FredObservationsDto

@OptIn(InternalKtorfitApi::class)
@ApiBinding(accessPoint = "fred")
public class _FredApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : FredApi {
  override suspend fun seriesObservations(
    seriesId: String,
    apiKey: String,
    fileType: String,
    observationStart: String,
    observationEnd: String,
  ): FredObservationsDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "fred/series/observations")
        seriesId?.let{ parameter("series_id", "$it") }
        apiKey?.let{ parameter("api_key", "$it") }
        fileType?.let{ parameter("file_type", "$it") }
        observationStart?.let{ parameter("observation_start", "$it") }
        observationEnd?.let{ parameter("observation_end", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<FredObservationsDto>(),)!! 
  }
}

public class _FredApiProvider : ClassProvider<FredApi> {
  override fun create(_ktorfit: Ktorfit): FredApi = _FredApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createFredApi(): FredApi = _FredApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
